import React, { createContext, FC } from "react";

import { BookingLabelsDto } from '@apiModels/BookingLabelsDto.csharp';

type ContextProps = {
  bookingLabels: BookingLabelsDto;
  isLoading: boolean;
}

export const LabelsContext = createContext<Partial<ContextProps>>({});

type LabelsProviderProps = {
  bookingLabels: BookingLabelsDto
}

export const LabelsProvider: FC<LabelsProviderProps> = ({ children, bookingLabels }) => {
  return (
    <LabelsContext.Provider value={{ bookingLabels }}>
      {children}
    </LabelsContext.Provider>
  )
}

